var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Search = function Search(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 17.593 17.531' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('defs', null),
      React.createElement('path', { d: 'M17.588 16.83l-.698.698-4.413-4.412c-1.327 1.177-3.054 1.915-4.968 1.915A7.517 7.517 0 0 1-.008 7.514a7.517 7.517 0 1 1 15.034 0c0 1.881-.715 3.579-1.857 4.898l4.419 4.418zm-3.647-9.423a6.417 6.417 0 1 0-12.834-.002 6.417 6.417 0 0 0 12.834.002z',
        className: 'cls-1' })
    )
  );
};
/*eslint-enable */

export default Search;
//# sourceMappingURL=Search.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Search.js